<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 13:58:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/cardnote/index.vue
-->
<template>
  <div>
    <title-bar-back :title="'备注'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <van-field
      v-model="message"
      rows="6"
      autosize
      type="textarea"
      maxlength="140个字"
      placeholder="请添加备注"
      show-word-limit
    />
    <div :class="{ btn_can: message }" class="btn_note" @click="submitBtn">
      提交
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "CardNote",
  components: {
    TitleBarBack
  },
  data() {
    return {
      message: localStorage.getItem("pur-note") || "",
      purPage: ""
    };
  },
  mounted() {
    this.purPage = this.$route.query.purPage;
  },
  methods: {
    back() {
      this.$router.back();
    },
    submitBtn() {
      if (this.purPage === "pur") {
        localStorage.setItem("pur-note", this.message);
      }
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.btn_note {
  background: linear-gradient(
    270deg,
    rgba(251, 214, 146, 1) 0%,
    rgba(224, 175, 101, 1) 100%
  );
  border-radius: 22px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 40px;
  text-align: center;
  margin: 30px 15px 0;
  opacity: 0.5;
}
.btn_can {
  opacity: 1;
}
</style>
